import { Listeners } from "@opendaw/lib-std";
import { Address } from "@opendaw/lib-box";
export class FilteredSelection {
    #selection;
    #filter;
    #mapping;
    #set;
    #listeners;
    #subscription;
    constructor(selection, filter, mapping) {
        this.#selection = selection;
        this.#filter = filter;
        this.#mapping = mapping;
        this.#set = Address.newSet(addressable => addressable.address);
        this.#listeners = new Listeners();
        this.#selection.selected()
            .filter(element => this.#filter(element))
            .forEach(element => this.#set.add(this.#mapping.fy(element)));
        this.#subscription = this.#selection.catchupAndSubscribe({
            onSelected: (element) => {
                if (this.#filter(element)) {
                    const value = this.#mapping.fy(element);
                    this.#set.add(value);
                    this.#listeners.proxy.onSelected(value);
                }
            },
            onDeselected: (element) => {
                if (this.#filter(element)) {
                    this.#listeners.proxy.onDeselected(this.#set.removeByKey(element.address));
                }
            }
        });
    }
    terminate() { this.#subscription.terminate(); }
    select(...selectables) {
        this.#selection.select(...selectables.map(selectable => this.#mapping.fx(selectable)));
    }
    deselect(...selectables) {
        this.#selection.deselect(...selectables.map(selectable => this.#mapping.fx(selectable)));
    }
    deselectAll() {
        this.#selection.deselect(...(this.#set.values().map(selectable => this.#mapping.fx(selectable))));
    }
    distance(inventory) {
        return this.#selection.distance(inventory.map(selectable => this.#mapping.fx(selectable))).map(item => this.#mapping.fy(item));
    }
    isEmpty() { return this.#set.size() === 0; }
    nonEmpty() { return this.#set.size() > 0; }
    count() { return this.#set.size(); }
    isSelected(selectable) { return this.#set.hasKey(selectable.address); }
    selected() { return this.#set.values(); }
    subscribe(listener) {
        return this.#listeners.subscribe(listener);
    }
    catchupAndSubscribe(listener) {
        this.#set.forEach(selectable => listener.onSelected(selectable));
        return this.subscribe(listener);
    }
}
